import { fetchPropertyOfferMap } from 'actions/OfferActions'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_BED_BANK } from 'constants/offer'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

type Return = [
  mapping: App.PropertyOfferMapping | undefined,
  fetching: boolean,
  error: any,
]

function usePropertyOfferMapping(
  offerType: typeof OFFER_TYPE_ALWAYS_ON | typeof OFFER_TYPE_BED_BANK,
  offerId: string | undefined = '',
  options: { disabled?: boolean } = {},
): Return {
  const dispatch = useAppDispatch()

  const mapping = useAppSelector(state => state.offer.propertyOfferMappings[offerId])

  useEffect(() => {
    if (!options.disabled && offerId) {
      dispatch(fetchPropertyOfferMap(offerType, offerId))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerType, offerId, options.disabled])

  return [
    mapping?.mapping,
    mapping?.fetching ?? !options.disabled,
    mapping?.error,
  ]
}

export default usePropertyOfferMapping
